var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "ConfirmationModal", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c(
          "div",
          { staticClass: "modal-content first-modal-content" },
          [
            _c(
              "div",
              { staticClass: "modal-header scnd-cancelModal-bgcolor" },
              [
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-target": "#ConfirmationModal",
                    },
                    on: { click: _vm.closePopup },
                  },
                  [_vm._v(" × ")]
                ),
                _vm._m(0),
              ]
            ),
            _c("div", { staticClass: "modal-body" }, [
              _c("p", { staticClass: "scnd-modal-service" }, [
                _vm._v("Thanks for trying out this service."),
              ]),
              _c("p", { staticClass: "scnd-service-para" }, [
                _vm._v(
                  " To help improve our services for the future, let us know why this service wasn’t right for you. "
                ),
              ]),
              _c("div", { staticClass: "textarea-field" }, [
                _c("p", [_vm._v("Reason:")]),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.reason,
                      expression: "reason",
                    },
                  ],
                  attrs: { cols: "30", rows: "2" },
                  domProps: { value: _vm.reason },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.reason = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "modal-footer cancelModal-bgcolor" }, [
              _c(
                "button",
                {
                  staticClass: "btn emergo-blue-button center-block submit-btn",
                  on: { click: _vm.requestCancel },
                },
                [_vm._v(" Submit ")]
              ),
            ]),
            _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-title service-modal-title" }, [
      _c("div", { staticClass: "cancel-successful" }, [
        _vm._v("Cancellation request"),
      ]),
      _c("div", { staticClass: "process-cancel" }, [
        _vm._v("Please allow 24-48 hours to process your cancellation."),
      ]),
      _c("hr", { staticClass: "process-hr-line" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }